import { BaseDto } from '@/shared/dtos/base-dto';

export class ventas_lineas extends BaseDto {
    public id_cabecera!: number;
    public id_producto!: number | null;
    public descripcion!: string;
    public imagen_url!: string;
    public cantidad!: number;
    public precio_amazon!: number;
    public precio_unitario!: number;
    public coste_unitario!: number;
    public descuento!: number;
    public total_linea!: number;
    public peso!: number;
    // campo calculado solo en memoria (no se guarda en BD)
    public base64?: string;
}
